import { useAnchorLinkWithHiddenParams } from 'hooks/useAnchorLinkWithHiddenParams';
import React from 'react';

interface ExternalLinkWithHiddenParamsProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  children: React.ReactNode;
  externalPath: string;
  externalParams: Record<string, string>;
  target?: string;
}

export const ExternalLinkWithHiddenParams: React.FC<ExternalLinkWithHiddenParamsProps> = ({
  children,
  externalPath,
  externalParams,
  target = '_blank',
  style,
  rel,
  ...rest
}) => {
  const href = useAnchorLinkWithHiddenParams(externalPath, externalParams);

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    e.stopPropagation();

    window.open(href, target);
  };

  return (
    <a href={externalPath} target={target} style={style} onClick={handleClick} rel={rel} {...rest}>
      {children}
    </a>
  );
};

